import React from "react";

export default function HotelAmenitiesSection() {
  const amenities = [
    "Complimentary toiletries",
    "Fresh towels (bath & hand)",
    "Television with cable",
    "Wi-Fi access",
    "Intercom",
    "Kettle / Tea–Coffee Maker",
    "Tea Bags, Coffee Sachets, Sugar, Creamer",
    "Drinking Water Bottles",
    "Blankets / Extra Pillows",
    "Room Heater (chargeable)",
    "Umbrella",
  ];

  return (
    <section className="w-full bg-gray-50 text-dark-green py-16 sm:py-24 font-['Cormorant_Garamond',serif]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16" data-aos="fade-up">
          <p className="text-beige text-lg tracking-[0.2em] font-medium uppercase">
            — Our Distinguished Offerings —
          </p>
          <h2 className="mt-4 text-5xl sm:text-6xl font-bold leading-tight text-dark-green">
            Hotel Amenities
          </h2>
          <p className="mt-6 max-w-4xl mx-auto text-xl leading-relaxed text-gray-700">
            We provide a comprehensive range of amenities to ensure your comfort and convenience throughout your stay.
          </p>
        </div>

        <div className="relative w-full max-w-6xl mx-auto" data-aos="fade-up">
          {/* Main Image */}
          <img
            src="/3.webp"
            alt="Elegant hotel interior"
            className="block w-full h-[600px] object-cover rounded-lg shadow-xl"
          />

          {/* Overlapping Amenities Card */}
          <div className="absolute top-[5%] right-0 transform -translate-y-1/2 bg-white p-10 md:p-12 rounded-lg shadow-2xl border border-gray-200 max-w-sm lg:max-w-md w-11/12 mx-auto lg:mx-0 overflow-y-auto max-h-[90%]" data-aos="fade-left" data-aos-delay="300">
            <h3 className="text-4xl font-semibold text-dark-green mb-8">A Collection of Refined Comforts</h3>
            <ul className="space-y-4 text-lg text-gray-800 leading-relaxed">
              {amenities.map((item, i) => (
                <li key={i} className="flex items-start">
                  <span className="text-beige mr-3 mt-1 text-xl">•</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}